/**
 * Hidden form input
 *
 * Hidden input based on React Admin's <DisabledInput>. Usefull to pass data like CSRF tokens.
 * Works well in <SimpleForm>, as it has the same props as other RA input components
 *
 * Docs:
 * https://gist.github.com/Danilo-Araujo-Silva/2ce11fd0540dcc7eb3ad3e67fd75d02a
 *
 * @example
 *    import { SimpleForm } from 'react-admin';
 *    import HiddenInput from '../../components/HiddenInput';
 *
 *    export const SampleParentComponent = () => (
 *      <SimpleForm record={{token: 'sampletoken}}>
 *        <HiddenInput source="token"/>
 *      </SimpleForm>
 *    );
 */

import React from 'react';
import { TextInput } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  invisible: {
    '&&': {
      display: 'none',
    },
  },
});

const HiddenInput = (props) => {
  const classes = useStyles();
  return <TextInput {...props} className={classes.invisible} disabled/>;
};

export default HiddenInput;
